import Vue from 'vue'
import Router from 'vue-router'
import Account from '@/pages/Account'
import Profile from '@/pages/Account/Profile'
import Devices from '@/pages/Account/Devices'
import AccessHistory from '@/pages/Account/AccessHistory'
import DealerTools from '@/pages/Account/DealerTools'
import CustomerTools from '@/pages/Account/CustomerTools'
import AdminTools from '@/pages/Account/AdminTools'
import Security from '@/pages/Account/Security'
import Login from '@/pages/Login'
import Logout from '@/pages/Logout'
import MyCallback from '@/pages/MyCallback'
import Loading from '@/pages/Loading'
import Signup from '@/pages/Signup'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/account',
      component: Account,
      children: [
        {
          path: 'profile',
          name: 'Profile',
          component: Profile
        },
        {
          path: 'security',
          name: 'Security',
          component: Security
        },
        {
          path: 'devices',
          name: 'Devices',
          component: Devices
        },
        {
          path: 'access-history',
          name: 'AccessHistory',
          component: AccessHistory
        },
        {
          path: 'dealer-tools',
          name: 'DealerTools',
          component: DealerTools
        },
        {
          path: 'customer-tools',
          name: 'CustomerTools',
          component: CustomerTools
        },
        {
          path: 'admin-tools',
          name: 'AdminTools',
          component: AdminTools
        },
        {
          path: '/',
          redirect: 'profile'
        },
        {
          path: '*',
          redirect: 'profile'
        }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      props: true
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout
    },
    {
      path: '/callback',
      name: 'Callback',
      component: MyCallback
    },
    {
      path: '/loading',
      name: 'Loading',
      component: Loading
    },
    {
      path: '/signup',
      name: 'Signup',
      component: Signup
    },
    {
      path: '/',
      redirect: 'loading'
    }
    // {
    //   path: '*',
    //   redirect: 'loading'
    // }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js